/** Freestanding drying frame with pegged joinery, hanging bunches and a shallow collecting tray. */
import { checkEnvelope, checkScope, el, partGroup } from '../../svg';
import type { PieceArt, PieceRecipe, ResolvedPalette } from '../../contract';
import { amount, beam, grainRng, ground, line, rivet } from './machinerySvg';
import { herbBundle } from './yardSvg';
export interface HerbRackParams { readonly bundles: number }
export type HerbRackRecipe = PieceRecipe<'mill.herb_rack.v1', HerbRackParams>;
export const HERB_RACK_FRAME = { w: 120, h: 120 } as const;
export const MILL_HERB_RACK: HerbRackRecipe = {
  schema: 'hush.asset-recipe.v1', id: 'mill.herb_rack.default.v1', generatorId: 'mill.herb_rack.v1',
  seed: 20071011, paletteId: 'millrace_amber', params: { bundles: 5 },
};
export function buildHerbRack(recipe: HerbRackRecipe, p: ResolvedPalette, scope: string): PieceArt {
  checkEnvelope(recipe, MILL_HERB_RACK.generatorId); checkScope(scope);
  const bundles = amount(recipe.params.bundles, 'bundles', 3, 6, true), random = grainRng(recipe), parts: string[] = [];
  const frame = beam(17, 110, 20, 15, 7, p) + beam(103, 110, 100, 15, 7, p)
    + beam(12, 22, 108, 22, 8, p) + beam(18, 94, 101, 94, 5, p)
    + beam(20, 53, 42, 25, 4, p) + beam(99, 53, 78, 25, 4, p)
    + beam(10, 112, 28, 112, 5, p) + beam(92, 112, 110, 112, 5, p)
    + rivet(20, 22, p) + rivet(100, 22, p);
  let herbs = '';
  for (let i = 0; i < bundles; i++) {
    const x = 29 + i * 62 / (bundles - 1), y = 37 + random(`tie.${i}`) * 7;
    herbs += line(x, 23, x, y, p.paperShadow, 1.2)
      + el('path', { d: `M${x - 2} 21Q${x - 3} 17 ${x + 1} 17Q${x + 4} 18 ${x + 2} 23`, fill: 'none', stroke: p.paperLight, 'stroke-width': 1 })
      + herbBundle(x, y, 38 + random(`length.${i}`) * 10, random, `bundle.${i}`, p);
  }
  const tray = el('path', { d: 'M24 101H96L92 109H29Z', fill: p.woodShadow, stroke: p.outline, 'stroke-width': 1 })
    + line(27, 102, 94, 102, p.woodLight, 2);
  const body = partGroup(parts, 'herb-rack-ground', ground(120, 120, p)) + partGroup(parts, 'herb-rack-joinery', frame)
    + partGroup(parts, 'drying-herb-bundles', herbs) + partGroup(parts, 'herb-collecting-tray', tray);
  return { frame: HERB_RACK_FRAME, body, anchors: { support: { x: 60, y: 120 }, hook_0: { x: 60, y: 22 } }, parts, openings: [] };
}
